<template>
    <div class="car">
        <custom-plane title="进场时间" :iconImg="require('@/assets/compImg/parking/time.png')">
            <div class="car_data  time">
                <!-- <div class="car_title">进场时间</div> -->
                <div class="car_infor">{{comeTime}}</div>
            </div>
        </custom-plane>
    </div>
</template>
<script>
export default {
    props: {
        comeTime: String
    }
}
</script>
<style lang="scss" scoped>
.car {
    margin-top: 20px;
    width: 416px;
    height: 127px;

    .time {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0;
    }
}
</style>